import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card } from '_atoms';
import { BreadCrumbs } from '_atoms/BreadCrumbs';
import { ExperienceTabContent } from '_molecules';
import { CandidateDetails } from '_organisms';
import { getCandidateInfo } from 'actions';
import { MixpanelService } from 'helpers/Mixpanel';
import { clearCandidateData } from 'store/reducers/candidateReducer';
import { getCandidateData } from 'store/selectors/candidateSelectors';
import type { AppDispatch } from 'store';
import './style.scss';

interface CandidateProfilePreviewProps {
  isSSC?: boolean;
}

export const CandidateProfilePreview: React.FC<CandidateProfilePreviewProps> = ({ isSSC }) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();

  const candidateData = useSelector(getCandidateData);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    dispatch(getCandidateInfo(id, isSSC, true));
    const mixpanel = new MixpanelService();
    mixpanel.track('View Page.Candidate Profile', {
      'Candidate ID': id,
    });

    return () => {
      dispatch(clearCandidateData());
    };
  }, []);

  const fullName =
    candidateData.first_name_latin && `${candidateData.first_name_latin} ${candidateData.last_name_latin}`;

  return (
    <div className="wrapper-content candidate-details-page">
      {!isSSC && (
        <BreadCrumbs
          element={t('translation:candidate_profile_preview.breadcrumb_candidates')}
          elementName={fullName}
          path="/candidates"
        />
      )}
      <div className="candidate-details-page__main-info">
        <CandidateDetails candidateData={candidateData} showAssignPopup={() => undefined} showShare isSSC={isSSC} />
        <Card className="candidate-job-experience">
          <div className="candidate-job-experience__content">
            <ExperienceTabContent candidateData={candidateData} />
          </div>
        </Card>
      </div>
    </div>
  );
};
